import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { NavBarTab } from "./nav-bar-tab";

export const NavBarTabs = () => {
  const { isAuthenticated } = useAuth0();

  return (
    <div className="nav-bar__tabs">
      <NavBarTab path="/leaderboard" label="Leaderboard" />
      <NavBarTab path="/auction-list" label="Auction List" />
      <NavBarTab path="/auction-results" label="Auction Results" />
      <NavBarTab path="/rules" label="Rules" />
      <NavBarTab path="/profile" label="Profile" />
      {isAuthenticated && (
        <>
          <NavBarTab path="/transfers" label="Transfers" />
          <NavBarTab path="/loans" label="Loans" />
          <NavBarTab path="/admin" label="Admin" />
          <NavBarTab path="/admin/site-vars" label="Site Variables" />
          <NavBarTab path="/admin/update-week" label="Update Week" />
          <NavBarTab path="/admin/team-admin" label="Team Admin" />
          <NavBarTab path="/score-breakdown" label="Score Breakdown" />
        </>
      )}
    </div>
  );
};
